module.exports = __webpack_public_path__ + "img/古川孝敏.263b5f89.png";